import React from 'react';
import { useClinicMasterProducts } from '../../../apis/clinic-master-products/hooks/useClinicMasterProducts';
import { useTablePagination } from '../../../hooks/useTablePagination';
import ClinicMasterProductsTable from '../components/ClinicMasterProductsTable';
import { LIMIT_OPTIONS } from '../../Services/constants';

interface ClinicMasterProductsTableContainerProps {
  clinicId: string;
}

const ClinicMasterProductsTableContainer = ({ clinicId }: ClinicMasterProductsTableContainerProps) => {
  const { rowsPerPage, page, handlePageChange, handleRowsPerPageChange } = useTablePagination();
  const { clinicMasterProducts, total, isLoading } = useClinicMasterProducts(clinicId, page, rowsPerPage);

  return (
    <ClinicMasterProductsTable
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={LIMIT_OPTIONS}
      onRowsPerPageChange={handleRowsPerPageChange}
      onPageChange={handlePageChange}
      total={total}
      clinicMasterProducts={clinicMasterProducts}
      isLoading={isLoading}
    />
  );
};

export default ClinicMasterProductsTableContainer;
